import WithLogin from './WithLogin';
import Lezer from './Lezer';

export default WithLogin(Lezer);
